import { useState } from "react";
import { ModalContext } from "./ModalContext";

const ModalContextProvider = ({ children }) => {
  const [visibility, setVisibility] = useState(false);
  const [walletModalvisibility, setModalvisibility] = useState(false);
  const [shareModalVisibility, setShareModalvisibility] = useState(false);
  const [oopsModalVisibility, setOopsModalVisibility] = useState(false);
  const [noWalletVisibility, setNoWalletModalVisibiltiy] = useState(false);
  const [successVisibility, setSuccessVisibility] = useState(false);
  const [message, setMessage] = useState(" ");
  const [hash, setHash] = useState(" ");



  const mintModalHandle = () => {
    setVisibility(!visibility);
  };
  const walletModalHandle = () => {
    setModalvisibility(!walletModalvisibility);
  };
  const shareModalHandle = (e) => {
    e.preventDefault();
    setShareModalvisibility(!shareModalVisibility);
  };
  const oopsModalHandle = () => {
    setOopsModalVisibility(!oopsModalVisibility);
  };
  const noWalletModalHandle = (e) => {
    e.preventDefault();
    setNoWalletModalVisibiltiy(!noWalletVisibility);
  };
  const successModalHandle = () => {
    setSuccessVisibility(!successVisibility);
  }
  const messageHandle = (msg) => {
    setMessage(msg);
  }
  const hashHandle = (hash) => {
    setHash(hash);
  }
  return (

    <ModalContext.Provider
      value={{
        visibility,
        mintModalHandle,
        walletModalHandle,
        walletModalvisibility,
        shareModalVisibility,
        shareModalHandle,
        oopsModalVisibility,
        oopsModalHandle,
        noWalletVisibility,
        noWalletModalHandle,
        message,
        messageHandle,
        hash,
        hashHandle,
        successVisibility,
        successModalHandle,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export default ModalContextProvider;
